import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { FormGroupArrayConfig } from '../../form-group-array.config';

@Component({
  selector: 'form-group-array-content-footer',
  templateUrl: './form-group-array-content-footer.component.html',
  styleUrls: ['./form-group-array-content-footer.component.scss'],
})
export class FormGroupArrayContentFooterComponent {
  @Input() config: FormGroupArrayConfig;
  @Input() formArray: UntypedFormArray;
  @Input() index: number;
  @Output() addDuplicateClicked: EventEmitter<{
    values: unknown;
    indexval: number;
  }> = new EventEmitter();

  addDuplicateForm(formValue: unknown, index: number) {
    this.addDuplicateClicked.emit({ values: formValue, indexval: index });
  }

  public isFormDisable(): boolean {
    return this.formArray?.length >= this.config?.maxLength;
  }
}
